'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.state.verticalScroll) {
        theme.listOverflowY = 'scroll';
    }

    if (this.state.horizontalScroll) {
        theme.listOverflowX = 'scroll';
    }

    var inputHeight = (0, _pixelToNumber2.default)(theme.fontSize) * theme.lineHeight + (0, _pixelToNumber2.default)(theme.paddingBottom) + (0, _pixelToNumber2.default)(theme.paddingTop);

    if (this.state.direction !== 'down') {
        theme.listBottom = 'calc(100% + 2px)';
        theme.listTop = 'auto';
        theme.listTransformOrigin = 'bottom';
    }

    if (this.state.horizontalDirection !== 'left') {
        theme.listLeft = 'auto';
        theme.listRight = 0;
    }

    if (!isNaN(this.props.maxLength)) {
        theme.listMaxHeight = inputHeight * this.props.maxLength + theme.gutter * 2 + (this.state.horizontalScroll ? 15 : 0) + 'px';
    }

    var iconTransform = {};

    theme = Object.assign({}, theme, {
        color: theme.hoverColor,
        placeholder: theme.idlePlaceholder,
        labelColor: theme.idleLabelColor,
        borderColor: theme.idleBorderColor,
        borderStyle: theme.idleBorderStyle,
        borderWidth: theme.idleBorderWidth,
        borderTransform: theme.idleBorderTransform,
        borderRadius: theme.idleBorderRadius,
        appearance: theme.appearanceImage,
        background: theme.idleBackground,
        boxShadow: theme.idleBoxShadow,
        outline: theme.idleOutline
    });

    if (this.state.hover) {
        theme = Object.assign({}, theme, {
            color: theme.hoverColor,
            placeholder: theme.hoverPlaceholder,
            labelColor: theme.hoverLabelColor,
            borderColor: theme.hoverBorderColor,
            borderStyle: theme.hoverBorderStyle,
            borderWidth: theme.hoverBorderWidth,
            borderTransform: theme.hoverBorderTransform,
            borderRadius: theme.hoverBorderRadius,
            appearance: theme.appearanceImageHover,
            background: theme.hoverBackground,
            boxShadow: theme.hoverBoxShadow,
            outline: theme.hoverOutline
        });
    }

    if (this.state.active) {
        theme = Object.assign({}, theme, {
            color: theme.focusColor,
            placeholder: theme.focusPlaceholder,
            labelColor: this.props.error ? theme.errorLabelColor : theme.focusLabelColor,
            borderColor: theme.focusBorderColor,
            borderStyle: theme.focusBorderStyle,
            borderWidth: theme.focusBorderWidth,
            borderTransform: theme.focusBorderTransform,
            borderRadius: theme.focusBorderRadius,
            appearance: theme.appearanceImageHover,
            background: theme.focusBackground,
            boxShadow: theme.focusBoxShadow,
            outline: theme.focusOutline
        });

        iconTransform = {
            transform: 'rotate(180deg)'
        };
    }

    if (this.props.error) {
        theme = Object.assign({}, theme, {
            color: theme.errorColor,
            placeholder: theme.errorPlaceholder,
            borderColor: theme.errorBorderColor,
            borderStyle: theme.errorBorderStyle,
            borderWidth: theme.errorBorderWidth,
            borderTransform: theme.errorBorderTransform,
            borderRadius: theme.errorBorderRadius,
            background: theme.errorBackground,
            boxShadow: theme.errorBoxShadow,
            outline: theme.errorOutline
        });
    }

    if (this.props.disabled || this.props.readOnly) {
        theme = Object.assign({}, theme, {
            color: theme.disabledColor,
            placeholder: theme.disabledPlaceholder,
            labelColor: theme.disabledLabelColor,
            borderStyle: theme.disabledBorderStyle,
            borderColor: theme.disabledBorderColor,
            borderWidth: theme.disabledBorderWidth,
            borderTransform: theme.disabledBorderTransform,
            borderRadius: theme.disabledBorderRadius,
            appearanceOpacity: 0.15,
            appearance: theme.appearanceImage,
            background: theme.disabledBackground,
            boxShadow: theme.disabledBoxShadow,
            outline: theme.disabledOutline
        });
    }

    if (this.props.inline) {
        theme.display = 'inline-block';
    }

    var field = {
        fontSize: theme.fontSize,
        lineHeight: theme.lineHeight,
        color: theme.color,
        width: '100%',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        background: 'transparent',
        border: '0 none',
        fontFamily: theme.fontFamily,
        paddingBottom: theme.paddingBottom,
        paddingTop: theme.paddingTop,
        paddingRight: theme.paddingRight,
        paddingLeft: theme.paddingLeft,
        margin: 0,

        '&::placeholder': {
            color: theme.placeholder
        },

        '&:focus, &:active': {
            outline: '0 none'
        }
    },
        item = {
        fontSize: theme.fontSize,
        lineHeight: theme.lineHeight,
        paddingRight: theme.listItemPaddingRight,
        paddingLeft: theme.listItemPaddingLeft,
        paddingTop: theme.paddingTop,
        paddingBottom: theme.paddingBottom,

        borderTop: theme.listItemBorderTop,
        borderBottom: theme.listItemBorderBottom,
        borderLeft: theme.listItemBorderLeft,
        borderRight: theme.listItemBorderRight,
        border: theme.listItemBorder,

        color: theme.listItemColor,
        background: theme.listItemBackground,
        fontFamily: theme.fontFamily,
        minWidth: '100%',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        margin: 0,
        position: 'relative',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        outline: '0 none',
        display: 'block',

        '&:focus': {
            cursor: 'pointer',
            outline: '0 none',
            color: theme.listItemFocusColor,
            background: theme.listItemFocusBackground
        },

        '&:hover': {
            cursor: 'pointer',
            background: theme.listItemHoverBackground,
            color: theme.listItemHoverColor,
            outline: '0 none'
        }
    };

    // рамка со всех сторон, классический инпут
    // скрываем нижнюю границу, применяем стиль к инпуту напрямую
    var wrappedBorder = !/none/.test(theme.borderStyle),
        passiveBorderOpacity = wrappedBorder || this.props.disabled ? 0 : 1,
        activeBorderOpacity = wrappedBorder ? 0 : 1,
        fieldBorder = {};

    if (wrappedBorder) {
        fieldBorder = {
            borderStyle: theme.borderStyle,
            borderColor: theme.borderColor,
            borderWidth: theme.borderWidth,
            borderRadius: theme.borderRadius
        };

        inputHeight += (0, _pixelToNumber2.default)(theme.borderWidth) * 2;
    }

    var scrollStyle = {};
    if (window && /WebKit/i.test(window.navigator.userAgent)) {
        scrollStyle = {
            '&::-webkit-scrollbar': {
                width: theme.gutter / 2 + 'px'
            },
            '&::-webkit-scrollbar:horizontal': {
                height: theme.gutter / 2 + 'px'
            },
            '&::-webkit-scrollbar-button': {
                display: 'none'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: theme.elDivider,
                borderRadius: '100px',
                transition: 'background ' + theme.transitionDuration + ' ' + theme.transitionFunction,

                '&:hover': {
                    background: theme.elDarkest
                }
            },
            '&::-webkit-scrollbar-corner': {
                display: 'none'
            },
            '&::-webkit-resizer': {
                display: 'none'
            }
        };
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            fontFamily: theme.fontFamily,
            color: theme.color,
            display: theme.display,
            width: theme.width,
            minWidth: theme.minWidth
        },
        label: {
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            color: theme.labelColor,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            width: '100%',
            display: 'block',
            textAlign: 'left'
        },
        input: Object.assign({
            position: 'relative',
            height: inputHeight + 'px',
            transitionDuration: theme.transitionDuration,
            transitionFunction: theme.transitionFunction,
            transitionProperty: 'transform, border-color',
            background: theme.background,
            boxShadow: theme.boxShadow
        }, fieldBorder),
        field: field,
        fieldWrapper: {
            position: 'relative',
            padding: '0 24px 0 0',
            background: 'transparent',
            border: '0 none',
            lineHeight: 'normal',
            width: '100%',
            textAlign: 'left',
            margin: 0,
            height: '100%',
            outline: theme.outline,
            boxSizing: 'border-box',

            '&:focus, &:active': {
                outline: '0 none'
            },

            '&:hover': {
                cursor: 'pointer !important'
            }
        },
        icon: Object.assign({
            position: 'absolute',
            top: 'calc(50% - 12px)',
            right: 0,
            width: '24px',
            height: '24px',
            backgroundImage: theme.appearance,
            opacity: theme.appearanceOpacity,
            transition: 'transform ' + theme.transitionDuration + ' ' + theme.transitionFunction
        }, iconTransform),
        list: Object.assign({
            position: 'absolute',
            paddingTop: theme.gutter + 'px',
            paddingBottom: theme.gutter + 'px',
            paddingLeft: 0,
            paddingRight: 0,
            top: theme.listTop,
            bottom: theme.listBottom,
            left: theme.listLeft,
            right: theme.listRight,
            background: theme.listBackground,
            border: '0 none',
            boxShadow: theme.listBoxShadow,
            zIndex: theme.listZIndex,
            overflow: 'hidden',
            minWidth: '100%',
            overflowY: theme.listOverflowY,
            overflowX: theme.listOverflowX,
            maxHeight: theme.listMaxHeight
        }, scrollStyle, {
            outline: '0 none'
        }),
        item: item,
        itemSelected: Object.assign({}, item, {
            color: theme.listItemSelectedColor,
            background: theme.listItemSelectedBackground,

            '&:focus': Object.assign({}, item['&:focus'], {
                color: theme.listItemFocusSelectedColor,
                background: theme.listItemFocusSelectedBackground
            }),

            '&:hover': Object.assign({}, item['&:hover'], {
                color: theme.listItemHoverSelectedColor,
                background: theme.listItemHoverSelectedBackground
            })
        }),
        itemFocused: Object.assign({}, item, {
            outline: '0 none',
            color: theme.listItemFocusColor,
            background: theme.listItemFocusBackground
        }),
        border: {
            borderImage: 'none',
            borderStyle: 'none none solid',
            boxSizing: 'content-box',
            height: 0,
            margin: 0,
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderColor: theme.idleBorderColor,
            borderWidth: 'medium medium ' + theme.idleBorderWidth,
            opacity: passiveBorderOpacity
        },
        activeBorder: {
            borderWidth: 'medium medium ' + theme.borderWidth,
            borderImage: 'none',
            borderStyle: theme.borderStyle,
            boxSizing: 'content-box',
            height: 0,
            margin: 0,
            transitionDuration: theme.transitionDuration,
            transitionFunction: theme.transitionFunction,
            transitionProperty: 'transform, border-color',
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderColor: theme.borderColor,
            transform: theme.borderTransform,
            opacity: activeBorderOpacity
        },
        animation: {
            transition: 'opacity 300ms ' + theme.transitionFunction + ', transform 450ms ' + theme.transitionFunction,
            transformOrigin: theme.listTransformOrigin,

            '&-enter': {
                opacity: 0.5,
                transform: 'scaleY(0)'
            },

            '&-enter-active': {
                opacity: 1,
                transform: 'scaleY(1)'
            },
            '&-exit': {
                opacity: 1,
                transform: 'scaleY(1)'
            },
            '&-exit-active': {
                opacity: 0,
                transform: 'scaleY(0)'
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        activeBorder: (0, _aphroditeJss.css)(styleList.activeBorder),
        border: (0, _aphroditeJss.css)(styleList.border),
        itemSelected: (0, _aphroditeJss.css)(styleList.itemSelected),
        item: (0, _aphroditeJss.css)(styleList.item),
        list: (0, _aphroditeJss.css)(styleList.list),
        icon: (0, _aphroditeJss.css)(styleList.icon),
        fieldWrapper: (0, _aphroditeJss.css)(styleList.fieldWrapper),
        field: (0, _aphroditeJss.css)(styleList.field),
        input: (0, _aphroditeJss.css)(styleList.input),
        itemFocused: (0, _aphroditeJss.css)(styleList.itemFocused),
        label: (0, _aphroditeJss.css)(styleList.label),
        animation: (0, _aphroditeJss.css)(styleList.animation)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

var _dd_triangle_down = require('../img/dd_triangle_down.svg');

var _dd_triangle_down2 = _interopRequireDefault(_dd_triangle_down);

var _dd_triangle_down_hover = require('../img/dd_triangle_down_hover.svg');

var _dd_triangle_down_hover2 = _interopRequireDefault(_dd_triangle_down_hover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        appearanceImageHover: 'url("' + _dd_triangle_down_hover2.default + '")',
        appearanceImage: 'url("' + _dd_triangle_down2.default + '")',
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,

        fontSize: theme.tsNormal,
        lineHeight: 1.5,
        fontFamily: theme.fontFamily,
        paddingTop: theme.gutter + 'px',
        paddingBottom: theme.gutter + 'px',
        paddingRight: 0,
        paddingLeft: 0,

        listBackground: theme.elPrimary,
        listBoxShadow: '0 6px 10px 0 ' + theme.elShadow + ', 0 4px 10px 0 ' + theme.elShadow,
        listZIndex: theme.zOverlay,
        listOverflowY: 'hidden',
        listOverflowX: 'hidden',
        listBottom: 'auto',
        listTop: 'calc(100% + 2px)',
        listLeft: 0,
        listRight: 'auto',
        listMaxHeight: 'auto',
        listTransformOrigin: 'top',

        listItemColor: theme.tActive,
        listItemBackground: 'transparent',
        listItemPaddingLeft: theme.gutter * 3 + 'px',
        listItemPaddingRight: theme.gutter * 3 + 'px',
        listItemBorderTop: '0 none',
        listItemBorderBottom: '0 none',
        listItemBorderLeft: '0 none',
        listItemBorderRight: '0 none',
        listItemBorder: '0 none',

        listItemHoverBackground: theme.elLightest,
        listItemHoverColor: theme.tActive,

        listItemFocusColor: theme.tActive,
        listItemFocusBackground: theme.elLightest,

        listItemSelectedColor: theme.tAccent,
        listItemSelectedBackground: 'transparent',

        listItemFocusSelectedColor: theme.tAccent,
        listItemFocusSelectedBackground: theme.elLightest,

        listItemHoverSelectedColor: theme.tAccent,
        listItemHoverSelectedBackground: theme.elLightest,

        idleColor: theme.tFilled,
        idlePlaceholder: theme.tHint,
        idleLabelColor: theme.tLabel,
        idleBorderColor: theme.elDivider,
        idleBorderStyle: 'none none solid',
        idleBorderWidth: '1px',
        idleBorderTransform: 'scale(0)',
        idleBorderRadius: '0',
        idleBackground: 'transparent',
        idleBoxShadow: 'none',
        idleOutline: 'none',

        focusColor: theme.tActive,
        focusPlaceholder: theme.tPlaceholder,
        focusLabelColor: theme.tAccent,
        focusBorderColor: theme.elAccent,
        focusBorderStyle: 'none none solid',
        focusBorderWidth: '2px',
        focusBorderTransform: 'scaleX(1)',
        focusBorderRadius: '0',
        focusBackground: 'transparent',
        focusBoxShadow: 'none',
        focusOutline: 'none',

        hoverColor: theme.tFilled,
        hoverPlaceholder: theme.tHint,
        hoverLabelColor: theme.tLabel,
        hoverBorderColor: theme.elSecondary,
        hoverBorderStyle: 'none none solid',
        hoverBorderWidth: '2px',
        hoverBorderTransform: 'scaleX(1)',
        hoverBorderRadius: '0',
        hoverBackground: 'transparent',
        hoverBoxShadow: 'none',
        hoverOutline: 'none',

        disabledColor: theme.tDisabled,
        disabledLabelColor: theme.tLabel,
        disabledPlaceholder: theme.tPlaceholder,
        disabledBorderTransform: 'scaleX(1)',
        disabledBorderStyle: 'none none dotted',
        disabledBorderWidth: '2px',
        disabledBorderColor: theme.elDivider,
        disabledBorderRadius: '0',
        disabledBackground: 'transparent',
        disabledBoxShadow: 'none',
        disabledOutline: 'none',

        errorColor: theme.tFilled,
        errorLabelColor: theme.tError,
        errorPlaceholder: theme.tHint,
        errorBorderColor: theme.elError,
        errorBorderStyle: 'none none solid',
        errorBorderWidth: '2px',
        errorBorderTransform: 'scaleX(1)',
        errorBorderRadius: '0',
        errorBackground: 'transparent',
        errorBoxShadow: 'none',
        errorOutline: 'none',

        width: 'auto',
        minWidth: 'auto'
    };
};